import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

// Structure commune à toutes les pages
function Layout() {
    return (
        <div className="bg-gray-950 text-white min-h-screen">
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default Layout;